import { ROLE } from "constants/phase";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setSelectedEntityId } from "store/entity/slice";
import LocalStorage from "utils/LocalStorage";

const useEntityIdSync = ({ entityId, isProfileLoaded = true, entityRole }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!isProfileLoaded || entityRole === ROLE.SUPER_ADMIN) {
      return;
    }

    const currentEntityId = LocalStorage.getItem("entityId");

    if (entityId && entityId !== currentEntityId) {
      dispatch(setSelectedEntityId(entityId));
    }
  }, [entityId, dispatch, isProfileLoaded, entityRole]);

  return { entityId: LocalStorage.getItem("entityId") };
};

export default useEntityIdSync;
